// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__N9x_2","insightsList":"newBusinessInsightsMenu_insightsList__1WCfx","active":"newBusinessInsightsMenu_active__3A3e3"};